export const environment = {
  production: false,
  stage: 'development',
  apiUrl: 'https://kenvue-dev-api.azurewebsites.net/api/kenvue',
  msalConfig: {
    defaultScopeName: 'https://digitalmouldsdev2.onmicrosoft.com/kenvue/user_impersonation',
    tenant: 'digitalmouldsdev2',
    tenantId: '07874da1-c500-4c96-885c-2d5b0efff7c4',
    signInPolicy: 'B2C_1_sign_in',
    clientId: '3c99a973-b1a4-4aa7-89f8-36ceac81f410',
    loginUrl: 'login-dev.digitalmoulds.com',
  },
  googleMapsApiKey: 'AIzaSyDh5Tvx632kO26H21ZAlO3lGE-WKe915aY'
};
